enum Steps {
    BasicDetails,
    ResetPeriod,
    Conditions,
}

export default Steps;
